exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3p1hD {\n  border-top: 1px solid #88733C;\n  background-color: #F6F4F0;\n  margin-left: -15px;\n  margin-right: -15px;\n}\n._3p1hD ._3ajID .Vjl9j {\n  position: relative;\n  text-align: center;\n  padding: 0;\n  display: inline-block;\n  width: calc(100% - 115px);\n}\n._3p1hD ._3ajID ._20HTy {\n  display: inline-block;\n  position: relative;\n  width: 100px;\n  text-align: right;\n}\n._3p1hD ._3ajID ._20HTy button {\n  border-radius: 10px;\n}\n._3p1hD ._37skF {\n  cursor: pointer;\n}\n._3p1hD ._37skF ._1ZXui {\n  margin-top: 4px;\n}\n._1TO4X {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n", ""]);

// Exports
exports.locals = {
	"searchBar": "_3p1hD",
	"searchContainer": "_3ajID",
	"search": "Vjl9j",
	"btnSearch": "_20HTy",
	"button": "_37skF",
	"icon": "_1ZXui",
	"list": "_1TO4X"
};